const DeliveryPassService = function ($q, restangular) {
    this._api = restangular.one('DeliveryPass');
    this.$q = $q;
    this.deliveryPassPrompt = undefined;
    this.deliveryPassesInTrolley = [];
    this.deliveryPasses = [];
};

DeliveryPassService.prototype.showShopperDeliveryPassPrompt = function () {
    return this.deliveryPassPrompt
        ? this.$q.when(this.deliveryPassPrompt)
        : this._fetchShopperDeliveryPassPrompt();
};

DeliveryPassService.prototype._fetchShopperDeliveryPassPrompt = function () {
    return this._api.one('Prompt').get().then((response) => {
        this.deliveryPassPrompt = response.plain();
        return this.deliveryPassPrompt;
    });
};

DeliveryPassService.prototype._fetchShopperDeliveryPasses = function () {
    return this._api.getList().then((response) => {
        this.deliveryPasses = response;
    });
};

DeliveryPassService.prototype.hasDeliveryPassInTrolley = function () {
    return this.deliveryPassesInTrolley.length > 0;
};

module.exports = DeliveryPassService;



// WEBPACK FOOTER //
// ./src/common/deliverypass/delivery-pass.service.js